export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
      <div className="portfolio--container">
      <p className="section--title">Background and Passion</p>
      <h1 className="skills-section--heading">About Me</h1>
        <div className="about--section--content--box about--section--box">
          <div className="about--section--content">
            <br></br>
            <br></br>
            <p className="about--section-description">
              Hello, I’m Guillermo Kramsky, a passionate coder. I find joy in the creative, logical, and empowering aspects of coding. I thrive on discipline and consistency.
            </p>
            <p className="about--section-description">
              I recently graduated from the Apple Developer Academy, where I refined my iOS development skills and became a more proficient app developer.
            </p>
            <p className="about--section-description">
              Additionally, I was selected for the Academy’s ARTE program, which accepts only 20 participants, and I’m one of the 16 developers chosen.
            </p>
            <p className="about--section-description">
              It is an amazing opportunity to work on cutting-edge projects with new technologies in collaboration with researchers at Federico II, focusing on spatial computing and visionOS app development.
            </p>
            <p className="about--section-description">
              Beyond coding, I maintain a healthy fitness routine, socialize with friends, explore new destinations, and enjoy the opportunities that this limited journey called life has to offer.
            </p>
          </div>
          <div className="about--section--image">
            <img src="./img/avatar-image-3.jpg" alt="Image description" />
          </div>
        </div>
      </div>
    </section>
  );
}
